import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SearchComponent } from './search/search.component';
import { AlternativeSearchesComponent } from './search/alternative-searches/alternative-searches.component';
import { FiltersComponent } from './search/filters/filters.component';
import { ResultsComponent } from './search/results/results.component';
import { SearchFormComponent } from './search/search-form/search-form.component';
import { ResultComponent } from './search/results/result/result.component';
import { DataService } from './shared/data.service';
import { LoadingSpinnerComponent } from './shared/loadingspinner/loadingspinner.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SearchService } from './search/search.service';
import { CompanyProfileComponent } from './profile/companyprofile/companyprofile.component';
import { ProfileService } from './profile/profile.service';
import { IndividualProfileComponent } from './profile/individual-profile/individual-profile.component';
import { FilterService } from './search/filters/filter.service';
import { CookieService } from './shared/cookie.service';
import { FeedbackComponent } from './feedback/feedback/feedback.component';
import { CompanyCreditComponent } from './profile/companyprofile/companycredit/companycredit.component';
import { CompanyCreditService } from './profile/companyprofile/companycredit/companycredit.service';
import { UserService } from './shared/user.service';
import { FeedbackService } from './feedback/feedback.service';
import { NouisliderModule } from 'ng2-nouislider';
import { NonmemberComponent } from './nonmember/nonmember.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SearchComponent,
    AlternativeSearchesComponent,
    FiltersComponent,
    ResultsComponent,
    SearchFormComponent,
    ResultComponent,
    LoadingSpinnerComponent,
    CompanyProfileComponent,
    IndividualProfileComponent,
    FeedbackComponent,
    CompanyCreditComponent,
    NonmemberComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    NouisliderModule
  ],
  providers: [DataService,SearchService,ProfileService,FilterService,CookieService,CompanyCreditService,UserService,FeedbackService],
  bootstrap: [AppComponent]
})
export class AppModule { }
